import { CountriesQuery } from 'src/generated/operations';
import { getCountryCodeOrDefault, getCountryData, getLocale } from 'src/bootstrap/parseSettingsFromUrl';
import { parseUrl } from 'src/utils/parseUrl';
import { UserSettings } from 'src/types/UserSettings';

function mapCodesToIso(country: string) {
    const upperCased = country.toUpperCase();
    if (upperCased === 'UK') {
        return 'GB';
    }
    return upperCased;
}

export function parseSettingsFromUrlOnBelimoHost(
    countries: CountriesQuery,
    global: Window = window,
): UserSettings | null {
    const { location } = global;
    const url = parseUrl(location.toString());

    if (!url) {
        return null;
    }

    const [, country = null, , language = null] = url.pathname.split('/');

    if (country === null || language === null) {
        return null;
    }
    const countryCodeFromUrl = getCountryCodeOrDefault(mapCodesToIso(country));
    const { code: countryCode, data: countryData } = getCountryData(countryCodeFromUrl, countries);

    if (!countryData) {
        return null;
    }

    return {
        countryDomain: countryData.domain,
        currentCountry: countryCode,
        currentRegion: countryData.region,
        currentLocale: getLocale(countryData, language),
        shoppingCenter: countryData.shoppingCenter ?? null,
    };
}
